module.exports = __webpack_public_path__ + "static/media/bow-arrow.d4c76858.svg";